import React, {useMemo, useState, createContext} from 'react';

export const UnderlineContext = createContext();

export const UnderlineProvider = ({children}) => {
  const [underlineId, setUnderlineId] = useState(null);
  const [searchUnderlineIds, setSearchUnderlineIds] = useState(null);
  const [underlineSection, setUnderlineSection] = useState(null);
  const [highlighSliderWord, setHighlighSliderWord] = useState(null);

  const value = useMemo(() => [
    [underlineId, setUnderlineId],
    [searchUnderlineIds, setSearchUnderlineIds],
    [underlineSection, setUnderlineSection],
    [highlighSliderWord, setHighlighSliderWord]
  ], [underlineId, searchUnderlineIds, underlineSection, highlighSliderWord]);

  return (
    <UnderlineContext.Provider value={value}>
      {children}
    </UnderlineContext.Provider>
  );
};
